(function() {
	'use strict';

	/**
	 * @ngdoc service
	 *
	 * @author maduka
	 * @description
	 *
	 */
	angular.module('paxMessageConfig')
			.factory('PaxMessageConfigFactory', PaxMessageConfigFactory);

	function PaxMessageConfigFactory() {

		function SearchDTO() {
			this.contryCode = null;

		}

		function SaveDTO(){
			this.countryCode = null;
			this.paxMsgtriggerId= null;
			this.countryName = null;
			this.startDate = null;
			this.endDate = null;
			this.paxMsgCountryId = null;
			this.triggers = [];
			this.paxMsgFields =[];
			this.paxMsgTypeId = null;
			this.status = 'ACT';
			this.version = null;
			this.zulu = true;
			this.paxMsgApisVersion = null;
			this.paxMsgCountryEmail = null;
			this.recipientIdentification = null;
			this.apisOperationTypes = null;
      this.messageReleaseNumber = null;
		}

		function GetSearchRequest() {
			return new SearchDTO();
		}

		function GetSaveRequest(){
			return new SaveDTO();
		}

		function GetEditorData(data){
			var edit = new  SaveDTO();
			edit.countryCode = data.countryCode;
			edit.paxMsgtriggerId = data.paxMsgtriggerId;
			edit.countryName = data.countryName;
			edit.startDate = data.startDate;
			edit.endDate = data.endDate;
			edit.paxMsgCountryId = data.paxMsgCountryId;
			edit.triggers = data.triggers;
			edit.paxMsgFields = data.paxMsgFields;
			edit.paxMsgTypeId = data.paxMsgTypeId;
			edit.status = data.status;
			edit.inactive = data.status ==='ACT'?false:true;
			edit.version = data.version;
			edit.zulu = data.zulu;
			edit.paxMsgApisVersion = data.paxMsgApisVersion;
			edit.paxMsgCountryEmail = data.paxMsgCountryEmail;
			edit.recipientIdentification = data.recipientIdentification;
      edit.messageReleaseNumber = data.messageReleaseNumber;
			edit.apisOperationTypes = data.apisOperationTypes;
			return edit;
		}

		return {
			getSearchRequest : GetSearchRequest,
			getSaveRequest :GetSaveRequest,
			editorData :GetEditorData

		}
	}
})();
